import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Comment from '@/components/Comment'
import Login from '@/components/Login'
import Users from '@/components/Users'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Analytics from '@/components/Analytics'
Vue.use(Router)
Vue.use(BootstrapVue)

export default new Router({
  routes: [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Analytics
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    }, {
      path: '/comment',
      name: 'Comment',
      component: Comment
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/users',
      name: 'Users',
      component: Users
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js